export * from './feedback-adapter.interface';
export * from './feedback-adapter.service';
export * from './feedback-adapter.mock';
export const FEEDBACK_ADAPTER_SERVICE = Symbol('FeedbackAdapterService');
